import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../screens/front/Login/Login.tsx";
import ProtectedRoute from "./ProtectedRoutes.tsx";
import Unauthorized from "./UnAuthorized.tsx";
import AdminDashboard from "../screens/admin/AdminDashboard/AdminDashboard.tsx";
import ManageAdmin from "../screens/admin/ManageAdmin/ManageAdmin.tsx"; // Import ManageAdmin component
import Home from "../screens/front/Home/Home.tsx";
import Layout from "../Components/Layout/Layout.tsx";
import EditAccessGroup from "../screens/admin/ManageAdmin/EditAccessGroup.tsx";
import AddOrUpdate from "../screens/admin/ManageAdmin/AddOrUpdateAdmin.tsx";
import ManageStore from "../screens/admin/ManageStore/ManageStore.tsx";
import AddOrUpdateStore from "../screens/admin/ManageStore/AddOrUpdateStore.tsx";
import ManageClients from "../screens/admin/ManageClients/ManageClients.tsx";
import AddOrUpdateClients from "../screens/admin/ManageClients/AddOrUpdateClients.tsx";
import ManageVenue from "../screens/admin/ManageVenue/ManageVenue.tsx";
import AddOrUpdateVenue from "../screens/admin/ManageVenue/AddOrUpdateVenue.tsx";
import ImportExportQuestions from "../screens/admin/ImportExportQuestions/ImportExportQuestions.tsx";
import ImportExportQuestionsManager from "../screens/admin/ImportExportQuestionsManager/ImporttExportQuestionsManager.tsx";
import AreaManager from "../screens/admin/AreaManager/AreaManager.tsx";
import AddOrUpdateAreaManager from "../screens/admin/AreaManager/AddOrUpdateAreaManager.tsx";
import VenueMap from "../screens/admin/ManageVenue/VenueMap.tsx";
import BriefJson from "../screens/admin/BriefJson/BriefJson.tsx";
import AddOrUpdateBriefJson from "../screens/admin/BriefJson/AddOrUpdateBriefJson.tsx";
import ViewEditorsBusiness from "../screens/admin/ManageStore/ViewEditorsBusiness.tsx";
import ViewEditorsVenue from "../screens/admin/ManageVenue/ViewEditorsVenue.tsx";
import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions.tsx";
import TrainingCalendar from "../screens/admin/TrainingCalendar/TrainingCalendar.tsx";
import ManageVisitTime from "../screens/admin/ManageVisitTime/ManageVisitTime.tsx";
import AddOrUpdateManageVisit from "../screens/admin/ManageVisitTime/AddOrUpdateManageVisit.tsx";
import ViewJobCriteriaBusiness from "../screens/admin/ManageStore/ViewJobCriteriaBusiness.tsx";
import ViewJobCriteriaVenue from "../screens/admin/ManageVenue/ViewJobCriteriaVenue.tsx";
import CreateAllocations from "../screens/admin/CreateAllocations/CreateAllocations.tsx";
import ApproveAllocation from "../screens/admin/ApproveAllocation/ApproveAllocation.tsx";
import ShopperApplications from "../screens/admin/ShopperApplications/ShopperApplications.tsx";
import ViewShopperApplication from "../screens/admin/ShopperApplications/ViewShopperApplication.tsx";
import OrphanAllocation from "../screens/admin/OrphanAllocation/OrphanAllocation.tsx";
import InviteShopper from "../screens/admin/OrphanAllocation/InviteShopper.tsx";
import MonthlyCalendar from "../screens/admin/MonthlyCalendar/MonthlyCalendar.tsx";
import CreateNewTemplate from "../screens/admin/CreateNewTemplate/CreateNewTemplate.tsx";
import QuestionBank from "../screens/admin/QuestionBank/QuestionBank.tsx";
import CreateNewQuestion from "../screens/admin/CreateNewQuestion/CreateNewQuestion.tsx";
import TemplateListing from "../screens/admin/Template Listing/TemplateListing.tsx";
import CreateClientTemplate from "../screens/admin/CreateClientTemplate/CreateClientTemplate.tsx";
import CreateVenueSiteTemplate from "../screens/admin/CreateVenueSiteTemplate copy/CreateVenueSiteTemplate.tsx";
import ManageReports from "../screens/admin/ManageReports/ManageReports.tsx";
import CreateOrEditScoreCard from "../screens/admin/ScoreCardComponents/CreateOrEditScoreCard.tsx";
import ShopperRequestDate from '../screens/admin/Shopper Req Date/ShopperRequestDate.tsx'
import StarRatingReport from "../screens/admin/RatingData/StarRatingReport.tsx";
import SpentReport from "../screens/admin/Report/SpentReport.tsx";
import RatingReportYTD from "../screens/admin/RatingData/RatingReportYTD.tsx";
import PositionRankingReport from "../screens/admin/RatingData/PositionRankingReport.tsx";
import QuizManagement from "../screens/admin/QuizManagement/QuizManagement.tsx";
import ShoppersList from "../screens/admin/ShopperList/ShoppersList.tsx";
import EditShopperProfile from "../screens/admin/ShopperList/EditShopperProfile.tsx";
import ShopperVenueMap from "../screens/admin/ShopperVenueMap/ShopperVenueMap.tsx";
import ManageRegions from "../screens/admin/ManageRegions/ManageRegions.tsx";
import AddOrUpdateRegion from "../screens/admin/ManageRegions/AddOrUpdateRegion.tsx";
import ViewAssignRegion from "../screens/admin/ManageStore/ViewAssignRegion.tsx";
import Categorylist from "../screens/admin/Category/Categorylist.tsx";
import AddorUpdateCategory from "../screens/admin/Category/AddorUpdateCategory.tsx";
import RegionBusinessDetails from "../screens/admin/RegionBusinessDetails/RegionBusinessDetails.tsx";
import AddOrEditRegionBusinessDetails from "../screens/admin/RegionBusinessDetails/AddOrEditRegionBusinessDetails.tsx";
import AirTaskerList from "../screens/admin/AirTasker/AirTaskerList.tsx";
import AirTasker from "../screens/admin/AirTasker/AirTasker.tsx";
import AirTaskerJobs from "../screens/admin/AirTasker/AirTaskerJobs.tsx";
import BundleAllocation from "../screens/admin/BundleAllocation/BundleAllocation.tsx";
import CreateBundleAllocation from "../screens/admin/BundleAllocation/CreateBundleAllocation.tsx";
import GenerateInvoice from "../screens/admin/Invoice/GenerateInvoice.tsx";
import EditorDashboard from "../screens/editor/EditorDashboard.tsx";
import EditorLayout from "../Components/Layout/EditorLayout.tsx";
import AllocationDetails from "../screens/admin/AllocationDetails/AllocationDetails.tsx";
import ImportExportAllocations from "../screens/admin/Import-Export-Allocations/ImportExportAllocations.tsx";
import UpdatePricing from "../screens/admin/Update Pricing/UpdatePricing.tsx";
import CompleteAllocation from "../screens/admin/CompleteAllocation/CompleteAllocation.tsx";
import PayInvoice from "../screens/admin/Invoice/PayInvoice.tsx";
import Invoicedetails from "../screens/admin/Invoice/Invoicedetails.tsx";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/venue-map" element={<VenueMap />} />

      {/* Protected Route for Admin Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AdminDashboard />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Protected Route for Manage Admin */}
      <Route
        path="/admin/manage-admin"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageAdmin /> {/* Use ManageAdmin component here */}
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/manage-store"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageStore />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-clients"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageClients />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/venue-managers"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageVenue />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/import-export"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportQuestions />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/import-export-manager"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportQuestionsManager />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/question-bank"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <QuestionBank />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/brief-json"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <BriefJson />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-template"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-client-template"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateClientTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-venue-site-template"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateVenueSiteTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-reports"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageReports />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/area-managers"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AreaManager />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/training-calendar"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <TrainingCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/clients-update/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateClients
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <AddOrUpdate
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-store/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateStore
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-venue/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateVenue
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-areamanager/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateAreaManager
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-briefjson/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateBriefJson
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/edit-access-group"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <EditAccessGroup />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-editor-business"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewEditorsBusiness
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-editor-site"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewEditorsVenue
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-business-jobcriteria"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewJobCriteriaBusiness
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-venue-jobcriteria"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewJobCriteriaVenue
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/manage-visit-times"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageVisitTime />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/export-pdf-excel"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportAllocations />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/add-or-update-visittime/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateManageVisit
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/create-monthly-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateAllocations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/approve-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ApproveAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/shoppers/shopper-application"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ShopperApplications />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/shoppers/view-shopper-application"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewShopperApplication />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/orphan-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <OrphanAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/Invite-Shopper"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <InviteShopper />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/allocations/monthly-calendar"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <MonthlyCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />
       <Route
        path="/admin/allocation-details/:allocationId?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AllocationDetails/>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/template-listing"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <TemplateListing />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-reports"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageReports />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/createOrEditScoreCard/:allocationId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateOrEditScoreCard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/allocations/shopper-date-request'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShopperRequestDate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/rating-data/star-rating-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <StarRatingReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/spent-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <SpentReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/create-quiz-question'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <QuizManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/shoppers-list'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShoppersList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/edit_shopper_profile'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <EditShopperProfile />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/shopper-venue-map'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShopperVenueMap />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-region"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageRegions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
       path='/admin/rating-data/position-ranking-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <PositionRankingReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/category-list'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <Categorylist />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/add-or-upate-category'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AddorUpdateCategory />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/add-or-update-region/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateRegion
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/region-business-details'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <RegionBusinessDetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/add-or-update-regionBusinessDetail/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrEditRegionBusinessDetails
                onSubmit={function (values: any): void {}}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/airtasker'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AirTaskerList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/shopper/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <AirTasker
                onSubmit={() => {}} mode="add"
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/airtasker-jobs"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <AirTaskerJobs />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/createbundle-allocations"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <CreateBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/bundle-allocations"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <BundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
     
      <Route
        path="/admin/invoices/generate-invoice"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <GenerateInvoice />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/pay-invoice"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <PayInvoice />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/invoice-details"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <Invoicedetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/dashboard"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <EditorDashboard />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/manage-report"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <ManageReports />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/monthly-calendar"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <MonthlyCalendar />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/update-pricing"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <UpdatePricing />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/view-completed-allocation"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <CompleteAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/rating-data/star-ranking-report-ytd"
        element={
          <ProtectedRoute allowedRoles={["1","2"]}>
            <Layout>
              <RatingReportYTD />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
